import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={54}
    height={54}
    fill="none"
    {...props}
  >
    <Path
      fill="#C0A46F"
      d="M53.524 26.762c-26.072.381-26.38.684-26.762 26.762C26.38 27.452 26.077 27.144 0 26.762 26.072 26.38 26.38 26.077 26.762 0c.381 26.077.684 26.386 26.762 26.762Z"
    />
  </Svg>
)
export default SvgComponent
